import * as Sentry from "@sentry/browser";
import {useAuthState} from "react-firebase-hooks/auth";
import {SurveySectionsRenderingModel} from "data/models/survey/base";
import {getAuth} from "firebase/auth";
import {isNullOrUndefined} from "helpers/is-null-or-undefined";
import {useObjectVal} from "react-firebase-hooks/database";
import {ref} from "firebase/database";
import {database} from "hooks/firebase";
import {choiceValuesFromKeys, multiSelectValues, singleSelectValue} from "helpers/choice-values";
import {MultiSelectValue} from "data/models/survey/multi-choice";
import {ChoiceValue} from "data/models/survey/choice-base";
import {SingleSelectValue} from "data/models/survey/single-choice";
import {
  HOPES_ASPIRATIONS_GOALS_CHOICES_MAP,
  PAINS_FEARS_IRRITATIONS_MAP
} from "data/definition/surveys/all-features/your-customers";
import {BUSINESS_TYPE_CHOICES_MAP} from "data/definition/surveys/all-features/business-info";
import {useMemo} from "react";
import {UserLoginValue} from "data/models/survey/login";


export function useSurveySectionsRenderingModel(): [
      SurveySectionsRenderingModel | null, boolean, Error | null
] {
  const auth = getAuth();
  const [user, userLoading, userError] = useAuthState(auth);
  const canvaAssetsPath = useMemo(() => `user-data/${user?.uid ?? ""}/user-surveys/canva-assets/all-features`, [user]);
  const [businessName, businessNameLoading, businessNameError] =
      useObjectVal<string>((user && ref(database, `${canvaAssetsPath}/business-info/business-name`)) ?? null);
  const [userLogin, userLoginLoading, userLoginError] =
      useObjectVal<UserLoginValue>((user && ref(database, `${canvaAssetsPath}/business-info/user-login`)) ?? null);

  if (
      userLoading
      || businessNameLoading
      || userLoginLoading
  ) {
    return [null, true, null];
  }

  const anError = (
      userError
      ?? businessNameError
      ?? userLoginError
  );
  if (anError) {
    Sentry.captureException(anError);
    return [null, false, anError];
  }

  if (
      isNullOrUndefined(user)
      || isNullOrUndefined(businessName)
      || isNullOrUndefined(userLogin)
  ) {
    return [null, false, null];
  }

  return [{
    businessName,
    userLogin
  },
    false,
    null
  ];
}


